import script from "./oasis-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./oasis-header.vue?vue&type=script&setup=true&lang=ts"

import "./oasis-header.vue?vue&type=style&index=0&id=12517e58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12517e58"]])

export default __exports__